export const REPORT_FINAL_STEP_1 = 'report_sent_1';
export const REPORT_FINAL_STEP_2 = 'report_sent_2';
export const REPORT_FINAL_STEP_3 = 'report_sent_3';

export const FLAG_VIOLENCE_OR_THREATS = 'violence_or_threats';
export const FLAG_POST_PRIVACY_CONCERN = 'post_privacy_concern';
